exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".image-video{position:relative}.image-video img{position:absolute;z-index:2;bottom:0}.relative{position:relative!important}.image-video video{vertical-align:bottom}.image-video iframe{position:absolute;top:0;left:0;width:100%;height:100%}.image-video-controls{z-index:3;color:#fff;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);cursor:pointer}.hide-image{opacity:0;z-index:-5!important}.image-video-controls .circle{height:60px;width:60px;background-color:rgba(0,0,0,.4);border-radius:50%;line-height:60px;margin:auto;position:relative}.image-video-controls i{font-size:20px;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.image-video-controls div{font-size:16px;margin-top:5px;font-weight:400}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./src/components/VideoImage/videoImage.scss
// module id = 164
// module chunks = 0